async function removeUpsellElements() {
  const upsellElements = document.querySelectorAll('.hc-upsell-cn');
  const url = '/browsing_context_suggestions.json';
  const response = await fetch(url);
  const data = await response.json();
  const country = data.detected_values.country_name;

  if (country === 'United States') {
    upsellElements.forEach(element => {
      element.remove();
    });

    const hc_sections = document.querySelectorAll('.hc-cn-section');
    hc_sections.forEach(function(section) {
      const upsells = section.querySelectorAll('.hc-upsell-wrapper');
      const upsellCount = upsells.length;
  
      if (upsellCount === 0) {
        const dataType = section.getAttribute('data-type');
        section.classList.add('hc-hidden-section');
        const matchingLeft = document.querySelector(`.hc-section-left[data-type="${dataType}"]`);
        if (matchingLeft) {
          matchingLeft.classList.add('hc-hidden-section');
        }
      }
    });
  }
}

async function sliderFiltering() {
  await removeUpsellElements();

  var hcColorActive = $('.hc-flow-color-active').attr('data-value');
  var hcSizeActive = $('.hc-main-slider').attr('data-value');
  var hcPadSelected = $('.hc-upsell-value-active[data-type="pad"]').eq(0).attr('data-product-title');
  var hcTarpSelected = $('.hc-upsell-value-active[data-type="tarp"]').eq(0).attr('data-product-title');
  var hcTarpSelectedVar = $('.hc-upsell-value-active[data-type="tarp"]').eq(0).attr('data-variant-title');

  if (window.innerWidth <= 1024) {
    hcColorsSwM.removeAllSlides();
    $(hcColorsMobile).each(function () {
      if ($(this).hasClass('hc-' + hcColorActive) && $(this).hasClass('hc-' + hcSizeActive)) {
        hcColorsSwM.appendSlide(this);
      } else {
        jQuery(this).remove();
      }
    });
    hcColorsSwM.update();
    hcColorsSwM.slideTo(0, false);

    $(hcPadsMobile).each(function () {
      if ($(this).hasClass('hc-' + hcColorActive) && $(this).hasClass('hc-' + hcSizeActive) && $(this).hasClass('hc-' + hcPadSelected) && !$(this).hasClass('hc-no-pad')) {
        hcPadsSwM.appendSlide(this);
      } else {
        jQuery(this).remove();
      }
    });
    hcPadsSwM.update();
    hcPadsSwM.slideTo(0, false);

    $(hcTarpMobile).each(function () {
      if ((
        $(this).hasClass('hc-' + hcColorActive) &&
        $(this).hasClass('hc-' + hcSizeActive) &&
        $(this).hasClass('hc-' + hcTarpSelected) &&
        $(this).hasClass('hc-' + hcTarpSelectedVar) &&
        !$(this).hasClass('hc-no-tarp')
      ) || (
        $(this).hasClass('hc-' + hcTarpSelected) &&
        $(this).hasClass('hc-' + hcTarpSelectedVar) &&
        $(this).hasClass('hc-tarp-general') &&
        !$(this).hasClass('hc-no-tarp')
      )) {
        hcTarpsSwM.appendSlide(this);
      } else {
        jQuery(this).remove();
      }
    });
    hcTarpsSwM.update();
    hcTarpsSwM.slideTo(0, false);

  } else {
    $(hcColors).each(function () {
      if ($(this).hasClass('hc-' + hcColorActive) && $(this).hasClass('hc-' + hcSizeActive)) {
        hcColorsSw.appendSlide(this);
      } else {
        jQuery(this).remove();
      }
    });
    hcColorsSw.update();
    hcColorsSw.slideTo(0, false);

    $(hcPads).each(function () {
      if ($(this).hasClass('hc-' + hcColorActive) && $(this).hasClass('hc-' + hcSizeActive) && $(this).hasClass('hc-' + hcPadSelected) && !$(this).hasClass('hc-no-pad')) {
        hcPadsSw.appendSlide(this);
      } else {
        jQuery(this).remove();
      }
    });
    hcPadsSw.update();
    hcPadsSw.slideTo(0, false);

    $(hcTarps).each(function () {
      if ((
        $(this).hasClass('hc-' + hcColorActive) &&
        $(this).hasClass('hc-' + hcSizeActive) &&
        $(this).hasClass('hc-' + hcTarpSelected) &&
        $(this).hasClass('hc-' + hcTarpSelectedVar) &&
        !$(this).hasClass('hc-no-tarp')
      ) || (
        $(this).hasClass('hc-' + hcTarpSelected) &&
        $(this).hasClass('hc-' + hcTarpSelectedVar) &&
        $(this).hasClass('hc-tarp-general') &&
        !$(this).hasClass('hc-no-tarp')
      )) {
        hcTarpsSw.appendSlide(this);
      } else {
        jQuery(this).remove();
      }
    });
    hcTarpsSw.update();
    hcTarpsSw.slideTo(0, false);
    $('.hc-colors-swiper').removeClass('hc-loading');
  }
}

(async () => {
  await sliderFiltering();
})();

$(window).on('resize orientationchange', function() {
  hcFiltering();
});

function hcWPCalculate(hcTypeItem, type){
  var hcWTotal = parseInt($('.hc-close-weight').attr('data-total-weight')) || 0;
  var hcPTotal = parseInt($('.hc-close-price').attr('data-total-price')) || 0;
  
  var hcWPads = parseInt($('.hc-close-weight').attr('data-pads-weight')) || 0;
  var hcWTarps = parseInt($('.hc-close-weight').attr('data-tarps-weight')) || 0;

  var hcPPads = parseInt($('.hc-close-price').attr('data-pads-price')) || 0;
  var hcPTarps = parseInt($('.hc-close-price').attr('data-tarps-price')) || 0;

  if(type == 'plus'){
    if(hcTypeItem == 'pad'){
      hcWTotal -= hcWPads;
      hcWTotal += parseInt($('.hc-added[data-type="pad"]').attr('data-weight'));
      
      hcPTotal -= hcPPads;
      hcPTotal += parseInt($('.hc-added[data-type="pad"]').attr('data-price'));
      
      $('.hc-close-weight').attr('data-pads-weight', $('.hc-added[data-type="pad"]').attr('data-weight'));
      $('.hc-close-price').attr('data-pads-price', $('.hc-added[data-type="pad"]').attr('data-price'));
    }
    if(hcTypeItem == 'tarp'){
      hcWTotal -= hcWTarps;
      hcWTotal += parseInt($('.hc-added[data-type="tarp"]').attr('data-weight')); 
      
      hcPTotal -= hcPTarps;
      hcPTotal += parseInt($('.hc-added[data-type="tarp"]').attr('data-price')); 
      
      $('.hc-close-weight').attr('data-tarps-weight', $('.hc-added[data-type="tarp"]').attr('data-weight'));
      $('.hc-close-price').attr('data-tarps-price', $('.hc-added[data-type="tarp"]').attr('data-price'));
    }
  }

  if(type == 'minus'){
    if(hcTypeItem == 'pad'){
      hcWTotal -= hcWPads;
      hcPTotal -= hcPPads;

      $('.hc-close-weight').attr('data-pads-weight', 0);
      $('.hc-close-price').attr('data-pads-price', 0);
    }
    if(hcTypeItem == 'tarp'){
      hcWTotal -= hcWTarps;
      hcPTotal -= hcPTarps;
      $('.hc-close-weight').attr('data-tarps-weight', 0);
      $('.hc-close-price').attr('data-tarps-price', 0);
    }
  }

  $('.hc-close-weight').text(hcWTotal);
  $('.hc-close-price').text(theme.Currency.formatMoney(hcPTotal, theme.settings.moneyFormat));

  $('.hc-close-weight').attr('data-total-weight', hcWTotal);
  $('.hc-close-price').attr('data-total-price', hcPTotal);
}

$(window).on('load', function() {
  const hcIndex = parseInt($('.hc-bundle-trigger-wrapper').attr('data-size-index'));
  var hcValue = $('.hc-bundle-trigger-wrapper').attr('data-value');
  var hcType = $('.hc-upsell-wrapper[data-value="'+hcValue+'"]:eq(0)').attr('data-type');
  var hcProduct = $('.hc-upsell-wrapper[data-value="'+hcValue+'"]:eq(0)').attr('data-product');

  var url = window.location.href;
  if(url.indexOf('#summary') != -1){
    $('.hc-drawer-content').css('display', 'block');
    $('body').addClass('hc-drawer-opened');
    $('.hc-add-trigger').hide();
    $('.hc-change-trigger').show();
  }else{
    $('.hc-add-trigger').show();
    $('.hc-change-trigger').hide();
  }   
  $('.hc-pad-items-wrapper .hc-upsell-wrapper[data-type="'+hcType+'"]').removeClass('hc-upsell-value-active');
  $('.hc-pad-items-wrapper .hc-upsell-wrapper[data-type="'+hcType+'"][data-value="'+hcValue+'"]').addClass('hc-upsell-value-active');
  
  $('.hc-tarp-items .hc-upsell-wrapper').addClass('hc-upsell-value-active');
  $('.hc-tarp-items .hc-upsell-wrapper').eq(0).addClass('hc-upsell-active');
  
  $('.hc-upsell-selected[data-type="'+hcType+'"]').removeClass('hc-upsell-product-active');
  $('.hc-upsell-selected[data-type="'+hcType+'"][data-value="'+hcValue+'"][data-product="'+hcProduct+'"]').addClass('hc-upsell-product-active');

  var hc_variant_id = $('.hc-upsell-wrapper[data-type="'+hcType+'"][data-value="'+hcValue+'"]').attr('data-variant');

  if($('.hc-upsell-wrapper[data-variant="'+hc_variant_id+'"]').hasClass('hc-variant-unavailable')){
    $('.hc-sold-out-message[data-type="'+hcType+'"]').removeClass('hc-sold-out-active');
    $('.hc-sold-out-message[data-variant="'+hc_variant_id+'"]').addClass('hc-sold-out-active');
  }

  const hcPriceUpdate = new CustomEvent("hcPriceUpdate", {
    bubbles: true,
    detail: hcType
  });
  document.dispatchEvent(hcPriceUpdate);
  
});

function hcFiltering(hcTypeItem, hcDefault){
  var hcColorActive = $('.hc-flow-color-active').attr('data-value');
  var hcSizeActive = $('.hc-main-slider').attr('data-value');
  var hcPadSelected = $('.hc-upsell-active[data-type="pad"]').attr('data-product-title');
  var hcTarpSelected = $('.hc-upsell-active[data-type="tarp"]').eq(0).attr('data-product-title');
  var hcTarpSelectedVar = $('.hc-upsell-active[data-type="tarp"]').eq(0).attr('data-variant-title');
  
  if(window.innerWidth <= 1024) {
    if(hcTypeItem == 'tarp'){
      $(hcTarpMobile).each(function () {
        if(hcDefault){
          if($(this).hasClass('hc-'+hcColorActive) && $(this).hasClass('hc-'+hcSizeActive) && $(this).hasClass('hc-'+hcTarpSelected) && $(this).hasClass('hc-'+hcTarpSelectedVar) && $(this).hasClass('hc-no-tarp')){          
            hcTarpsSwM.appendSlide(this);
          } else {
            jQuery(this).remove();
          }
        }else{
          if($(this).hasClass('hc-'+hcColorActive) && $(this).hasClass('hc-'+hcSizeActive) && $(this).hasClass('hc-'+hcTarpSelected) && $(this).hasClass('hc-'+hcTarpSelectedVar) && !$(this).hasClass('hc-no-tarp') || $(this).hasClass('hc-'+hcTarpSelected) && $(this).hasClass('hc-'+hcTarpSelectedVar) && $(this).hasClass('hc-tarp-general') && !$(this).hasClass('hc-no-tarp')){          
            hcTarpsSwM.appendSlide(this);
          } else {
            jQuery(this).remove();
          }
        }
      });
      
      hcTarpsSwM.update();
      hcTarpsSwM.slideTo(0, false);
  
    }else{ 
      $(hcPadsMobile).each(function () {
        if(hcDefault){
          if($(this).hasClass('hc-'+hcColorActive) && $(this).hasClass('hc-'+hcSizeActive) && $(this).hasClass('hc-no-pad')){          
            hcPadsSwM.appendSlide(this);
          } else {
            jQuery(this).remove();
          }
        }else{
          if($(this).hasClass('hc-'+hcColorActive) && $(this).hasClass('hc-'+hcSizeActive) && $(this).hasClass('hc-'+hcPadSelected) && !$(this).hasClass('hc-no-pad')){          
            hcPadsSwM.appendSlide(this);
          } else {
            jQuery(this).remove();
          }
        }
  
      });
    
      hcPadsSwM.update();
      hcPadsSwM.slideTo(0, false);
    }
  }else{
    if(hcTypeItem == 'tarp'){
      $(hcTarps).each(function () {
        if(hcDefault){
          if($(this).hasClass('hc-'+hcColorActive) && $(this).hasClass('hc-'+hcSizeActive) && $(this).hasClass('hc-'+hcTarpSelected) && $(this).hasClass('hc-'+hcTarpSelectedVar) && $(this).hasClass('hc-no-tarp')){          
            hcTarpsSw.appendSlide(this);
          } else {
            jQuery(this).remove();
          }
        }else{
          if($(this).hasClass('hc-'+hcColorActive) && $(this).hasClass('hc-'+hcSizeActive) && $(this).hasClass('hc-'+hcTarpSelected) && $(this).hasClass('hc-'+hcTarpSelectedVar) && !$(this).hasClass('hc-no-tarp') || $(this).hasClass('hc-'+hcTarpSelected) && $(this).hasClass('hc-'+hcTarpSelectedVar) && $(this).hasClass('hc-tarp-general') && !$(this).hasClass('hc-no-tarp')){          
            hcTarpsSw.appendSlide(this);
          } else {
            jQuery(this).remove();
          }
        }
      });
      
      hcTarpsSw.update();
      hcTarpsSw.slideTo(0, false);
  
    }else{  
      $(hcPads).each(function () {
        if(hcDefault){
          if($(this).hasClass('hc-'+hcColorActive) && $(this).hasClass('hc-'+hcSizeActive) && $(this).hasClass('hc-no-pad')){          
            hcPadsSw.appendSlide(this);
          } else {
            jQuery(this).remove();
          }
        }else{
          if($(this).hasClass('hc-'+hcColorActive) && $(this).hasClass('hc-'+hcSizeActive) && $(this).hasClass('hc-'+hcPadSelected) && !$(this).hasClass('hc-no-pad')){          
            hcPadsSw.appendSlide(this);
          } else {
            jQuery(this).remove();
          }
        }
      });
    
      hcPadsSw.update();
      hcPadsSw.slideTo(0, false);
    }
  }
}

$(document).on('click', '.hc-upsell-value-active', function() {
  const hcProduct = $(this).attr('data-product');
  const hcTypeItem = $(this).attr('data-type');
  const hcPrice = $(this).attr('data-price');
  const hcValue = $(this).attr('data-value');
  const hcVariant = $(this).attr('data-variant');

  $('.hc-upsell-value-active[data-type="'+hcTypeItem+'"]').removeClass('hc-upsell-active');
  $('.hc-upsell-value-active[data-type="'+hcTypeItem+'"]').removeClass('hc-added');
  
  $(this).addClass('hc-upsell-active');  

  if(!$(this).hasClass('hc-variant-unavailable')){
    $(this).addClass('hc-added');
  }

  $(this).attr('data-qty', $('.hc-qty[data-type="'+hcTypeItem+'"]').val());

  $('.hc-upsell-selected[data-type="'+hcTypeItem+'"]').removeClass('hc-upsell-product-active');
  $('.hc-upsell-selected[data-type="'+hcTypeItem+'"][data-value="'+hcValue+'"][data-product="'+hcProduct+'"]').addClass('hc-upsell-product-active');

  $('.hc-upsell-selected-info[data-type="'+hcTypeItem+'"]').removeClass('hc-upsell-product-active');
  $('.hc-upsell-selected-info[data-type="'+hcTypeItem+'"][data-product="'+hcProduct+'"]').addClass('hc-upsell-product-active');

  $('.hc-upsell-none[data-type="'+hcTypeItem+'"]').removeClass('hc-no-active');
  
  $('.hc-no-desc[data-type="'+hcTypeItem+'"]').hide();

  var hc_variant_id = $('.hc-upsell-wrapper[data-type="'+hcTypeItem+'"][data-product="'+hcProduct+'"]').attr('data-variant');

  if($(this).hasClass('hc-variant-unavailable')){
    $('.hc-sold-out-message[data-type="'+hcTypeItem+'"]').removeClass('hc-sold-out-active');
    $('.hc-sold-out-message[data-variant="'+hc_variant_id+'"]').addClass('hc-sold-out-active');
  }else{
    $('.hc-sold-out-message[data-type="'+hcTypeItem+'"]').removeClass('hc-sold-out-active');
  }

  if(!$(this).hasClass('hc-variant-unavailable')){
    hcWPCalculate(hcTypeItem, 'plus');
    hcFiltering(hcTypeItem, false);
  
    const hcType = {
      type: hcTypeItem,
      action: 'plus',
      price: hcPrice
    }
  }else{
    hcWPCalculate(hcTypeItem, 'minus');
    hcFiltering(hcTypeItem, false);
    
    const hcType = {
      type: hcTypeItem,
      action: 'minus',
      price: hcPrice
    }
  }

  const hcPriceUpdate = new CustomEvent("hcPriceUpdate", {
    bubbles: true,
    detail: hcTypeItem
  });
  document.dispatchEvent(hcPriceUpdate);
  
});

$(document).on('click', '.hc-upsell-none', function() {

  const hcTypeItem = $(this).attr('data-type');

  if(!$(this).hasClass('hc-no-active')){
    
    hcWPCalculate(hcTypeItem, 'minus');
    
    const hcPrice = 0;
    const hcType = {
      type: hcTypeItem,
      action: 'remove',
      price: hcPrice
    }
  
    $('.hc-no-pad-wrapper[data-type="'+hcTypeItem+'"]').addClass('hc-visible');
    $('.hc-pad-info[data-type="'+hcTypeItem+'"] .hc-custom-info-not-selected').addClass('hc-visible');
    
    $(this).addClass('hc-no-active');
    hcFiltering(hcTypeItem, true); 

    $('.hc-no-desc[data-type="'+hcTypeItem+'"]').show();
    $('.hc-upsell-value-active[data-type="'+hcTypeItem+'"]').removeClass('hc-upsell-active');
    $('.hc-upsell-value-active[data-type="'+hcTypeItem+'"]').removeClass('hc-added');

    const hcPriceUpdate = new CustomEvent("hcPriceUpdate", {
      bubbles: true,
      detail: hcType
    });
    document.dispatchEvent(hcPriceUpdate); 
    
  }
});

document.addEventListener("hcPriceUpdate", e => {
  const hcUpsellActive = $('.hc-added');
  var hcPrice, hcCompare;
  var hcTotal = 0;
  var hcWeightTotal = 0;
  var hcTotalDefault;
  var hcWeight;
  var hcType;
  var hcSummaryHtml = '';
  var hcTitle; var hcVariant; var hcImage; var hcQty; var hcValue;
  var hcWPadTotal = 0;
  var hcPPadTotal = 0; 
  var hcWTarpTotal = 0;
  var hcPTarpTotal = 0;
  
  if(hcUpsellActive.length){
    hcUpsellActive.each(function(index) {
      hcType = $(this).attr('data-type');
      hcTitle = $(this).attr('data-default-product');
      hcVariant = $(this).attr('data-variant');
      hcImage = $(this).attr('data-image');
      hcQty = parseInt($(this).attr('data-qty'));
      hcWeight = parseInt($(this).attr('data-weight'));
      hcValue = '';

      hcValue = ' - ' + $(this).attr('data-value');
      
      if(hcValue.indexOf('Default') != -1){
        hcValue = '';
      }
      if(!$('.hc-upsell-none[data-type="'+hcType+'"]').hasClass('hc-no-active') && hcQty != 0){
        hcPrice = parseInt($(this).attr('data-price'));
        hcCompare = parseInt($(this).attr('data-compare'));
        hcTotal += hcPrice * hcQty;
        if(hcType == 'pad'){
          hcWPadTotal += hcWeight;
          hcPPadTotal += hcPrice;
        }
        if(hcType == 'tarp'){
          hcWTarpTotal += hcWeight;
          hcPTarpTotal += hcPrice;
        }
        if(hcCompare == 0 || Number.isNaN(hcCompare)){
          hcCompare = '';
        }else{
          hcCompare = theme.Currency.formatMoney(parseInt(hcCompare, theme.settings.moneyFormat))
        }
        hcSummaryHtml += '<div class="hc-upsell-item"><div class="hc-upsell-image"><img src="'+hcImage+'"><div class="hc-upsell-title">'+hcTitle + hcValue + '</div></div>';
        hcSummaryHtml += '<div class="hc-price"><span class="hc-change-upsell" data-type="'+hcType+'">Change</span><span class="hc-price-qty">'+hcQty+' x '+theme.Currency.formatMoney(parseInt(hcPrice, theme.settings.moneyFormat))+'<span class="hc-compare">'+hcCompare+'</span></span></div>';
        hcSummaryHtml += '</div>';
      }else{
        hcPrice = $('.hc-upsell-active[data-type="'+hcType+'"]').attr('data-price');
        hcTotal -= hcPrice  * hcQty;
      }
      $('.hc-total-price').attr('data-price', hcTotal);
      $('.hc-total-price').text(theme.Currency.formatMoney(hcTotal, theme.settings.moneyFormat));
      
    });
  }else{
    $('.hc-total-price').attr('data-price', $('.hc-total-price').attr('data-price-init'));
    $('.hc-total-price').text(theme.Currency.formatMoney(parseInt($('.hc-total-price').attr('data-price-init')), theme.settings.moneyFormat));
  }
  $('.hc-bundle-summary-bottom').empty();
  $('.hc-bundle-summary-bottom').append(hcSummaryHtml);
});

$(document).on('click', '.hc-add-trigger', function(e) {
  
  e.preventDefault();

  const hcMainVariant = $(this).attr('data-variant');

  var queue = [];
  var options = $('.hc-added');
  var variant; var type;
  var product = $(this).attr('data-product'); var hcQty;
  
  $(options).each(function(hc_index) {
    variant = $(this).attr('data-variant');
    type = $(this).attr('data-type');
    hcQty = $(this).attr('data-qty');
    
     properties = {
      '_Bundle': 'Bundle',
      '_type': type,
      '_main': product
    };

    if(hc_index == 0){
       properties = {
        '_Bundle': 'Bundle',
        '_type': 'main'
      };
    }
    
    queue.push({ variant_id: variant, quantity_id: hcQty, properties: properties });
  });

  function moveAlong() {
    if (queue.length) {
      var request = queue.shift();
      var tempId = request.variant_id;
      var tempQty = request.quantity_id;
      var properties = request.properties;
      
      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: {
          quantity: tempQty,
          id: tempId,
          properties: properties
        },
        dataType: 'json',
        success: function(line_item) {
          moveAlong();
        },
        error: function(error) {
          var response = eval('(' + error.responseText + ')');
          response = response.description;
          alert(response);
        }
      };
      $.ajax(params);
    } else {
      window.location = "/cart";
    }
  };
  moveAlong();
});

$(document).on('click', '.hc-learn', function(e) {
  var hcType = $(this).attr('data-type');
  $('body').addClass('hc-popup-opened');
  $('.hc-popup-outer').addClass('show');
  $('.hc-popup-section').removeClass('hc-popup-active');
  $('.hc-popup-section[data-type="'+hcType+'"]').addClass('hc-popup-active');
  $('.hc-compare-slider').slick('refresh');
});
$(document).on('click', '.hc-reviews-wrapper', function(e) {
  var hcType = $(this).attr('data-type');
  $('body').addClass('hc-popup-opened');
  $('.hc-popup-outer').addClass('show');
  $('.hc-popup-content').addClass('hc-popup-reviews');
  $('.hc-popup-section').removeClass('hc-popup-active');
  $('.hc-popup-section[data-type="'+hcType+'"]').addClass('hc-popup-active');
});
$(document).on('click', '.hc-learn-close', function(e) {
  var hcType = $(this).attr('data-type');
  $('.hc-popup-outer').removeClass('show'); 
  $('body').removeClass('hc-popup-opened');
  $('.hc-popup-content').removeClass('hc-popup-reviews');
});

$(document).on('click', '.hc-bundle-weight-wrapper', function(e) {
  var hcType = $(this).attr('data-type');
  $('.hc-bundle-weight-info-wrapper[data-type="'+hcType+'"]').addClass('hc-visible');
});
$(document).on('click', '.hc-bundle-weight-close', function(e) {
  var hcType = $(this).attr('data-type');
  $('.hc-bundle-weight-info-wrapper[data-type="'+hcType+'"]').removeClass('hc-visible');
});

function updateCartQuantities(items) {
  var data = {
      updates: {}
  };

  items.forEach(function(item) {
    data.updates[item.id] = item.qty;
  });

  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(cart) {
      window.location = "/cart";
    },
    error: function(error) {
      var response = eval('(' + error.responseText + ')');
      response = response.description;
      alert(response);
    }
  });
}

$(document).on('click', '.hc-change-trigger', function(e) {
  
  var options = $('.hc-added');
  var variant;
  var hcQty;

  var itemsToUpdate = [];
  
  $(options).each(function(hc_index) {
    variant = $(this).attr('data-variant');
    hcQty = $(this).attr('data-qty');
    itemsToUpdate.push({ id: variant, qty: hcQty});    
  });

  updateCartQuantities(itemsToUpdate);
});

function calculateDistance(class1, class2) {
  const rect1 = document.querySelector(class1).getBoundingClientRect();
  const rect2 = document.querySelector(class2).getBoundingClientRect();
  const centerY1 = rect1.top;
  const centerY2 = rect2.top;
  var hcOffset = 100;
  if(window.innerWidth < 1024){
    hcOffset = 0;
  }
  const distance = centerY2 - centerY1 - hcOffset;
  return distance;
}

$(document).on('click', '.hc-change-upsell', function(e) {
  var hcType = $(this).attr('data-type');
  if(hcType == 'main'){
    $('.hc-drawer-content').css('display', 'none');
    $('body').removeClass('hc-drawer-opened');
  }else{
    const distance = calculateDistance('.hc-drawer-inner', '.hc-type-section[data-type="'+hcType+'"] .hc-type-header');
    $('.hc-popup-items').animate({ scrollTop: distance}, 500, 'linear');
  }
});
$(document).on('click', '.hc-size-swatch', function(e) {
  let hc_value = $(this).attr('data-value');
  $('.hc-selected-size').text(hc_value);
  $('.hc-size-swatch').removeClass('hc-checked');
  $(this).addClass('hc-checked');
  $('.variant-input[data-value="'+hc_value+'"] input').trigger('click');
  var hcSizes = $('.hc-expected-var.hc-option-'+hc_value);

});

$(document).on('click', '.hc-size-weight-wrapper', function(e) {
  $('.hc-size-weight-info-wrapper').addClass('hc-visible');
});

$(document).on('click', '.hc-size-weight-close', function(e) {
  $('.hc-size-weight-info-wrapper').removeClass('hc-visible');
});

$(document).on('click', '.hc-flow-color', function(e) {
  $('.hc-flow-color').removeClass('hc-flow-color-active');
  $(this).addClass('hc-flow-color-active');
  let hc_value = $(this).attr('data-value');
  let hc_value_lang = $(this).attr('data-color-lang');
  $('.variant-input[data-default-value="'+hc_value+'"] input').trigger('click');
  $('.hc-color-active').text(hc_value_lang);
});

var hcHistoryType = 'items';

window.addEventListener('scroll', function (e) {
  if (document.querySelector('.hc-drawer-content')) {
    const sections = document.querySelectorAll('.hc-type-section');
    let currentSection = null;

    for (let i = sections.length - 1; i >= 0; i--) {
      const section = sections[i];
      if (section.classList.contains('hc-hidden')) continue;

      const rect = section.getBoundingClientRect();
      if (rect.top <= window.innerHeight / 2 && rect.bottom > 0) {
        currentSection = section;
        break;
      }
    }

    if (currentSection) {
      const hcType = currentSection.getAttribute('data-type');

      document.querySelectorAll('.hc-section-left').forEach(left => {
        const type = left.getAttribute('data-type');
        const matchingRight = document.querySelector(`.hc-type-section[data-type="${type}"]`);
        const shouldShow = type === hcType &&
                           !left.classList.contains('hc-hidden') &&
                           !(matchingRight && matchingRight.classList.contains('hc-hidden-section'));
        left.classList.toggle('hc-shown', shouldShow);
      });

      hcHistoryType = hcType;

      if (hcType === 'pad' || hcType === 'tarp') {
        var $active = $(`.hc-type-section[data-type="${hcType}"] .hc-upsell-value-active`);
        var $current = $(`.hc-type-section[data-type="${hcType}"] .hc-upsell-value-active.hc-upsell-active`);
        var $none = $(`.hc-upsell-none[data-type="${hcType}"]`);
        var noneAdded = $active.filter('.hc-added').length === 0;

        if (noneAdded && !$none.hasClass('hc-no-active') && !$current.hasClass('hc-variant-unavailable')) {

          $active.eq(0).addClass('hc-added');

          const hcWeight = parseInt($('.hc-close-weight').attr('data-default-weight'));
          const hcPrice = parseInt($('.hc-close-price').attr('data-default-price'));

          let hcWeightTotal = hcWeight;
          let hcPriceTotal = hcPrice;

          if (hcType === 'pad') {
            const padWeight = parseInt($('.hc-added[data-type="pad"]').attr('data-weight')) || 0;
            const padPrice = parseInt($('.hc-added[data-type="pad"]').attr('data-price')) || 0;
            $('.hc-close-weight').attr('data-pads-weight', padWeight);
            $('.hc-close-price').attr('data-pads-price', padPrice);
            hcWeightTotal += padWeight;
            hcPriceTotal += padPrice;
          }

          if (hcType === 'tarp' || hcType === 'summary') {
            const padWeight = parseInt($('.hc-added[data-type="pad"]').attr('data-weight')) || 0;
            const padPrice = parseInt($('.hc-added[data-type="pad"]').attr('data-price')) || 0;
            const tarpWeight = parseInt($('.hc-added[data-type="tarp"]').attr('data-weight')) || 0;
            const tarpPrice = parseInt($('.hc-added[data-type="tarp"]').attr('data-price')) || 0;

            $('.hc-close-weight').attr('data-pads-weight', padWeight);
            $('.hc-close-price').attr('data-pads-price', padPrice);
            $('.hc-close-weight').attr('data-tarps-weight', tarpWeight);
            $('.hc-close-price').attr('data-tarps-price', tarpPrice);

            hcWeightTotal += padWeight + tarpWeight;
            hcPriceTotal += padPrice + tarpPrice;
          }

          $('.hc-close-weight').text(hcWeightTotal);
          $('.hc-close-price').text(theme.Currency.formatMoney(hcPriceTotal, theme.settings.moneyFormat));
          $('.hc-close-weight').attr('data-total-weight', hcWeightTotal);
          $('.hc-close-price').attr('data-total-price', hcPriceTotal);

          const hcPriceUpdate = new CustomEvent("hcPriceUpdate", {
            bubbles: true,
            detail: hcType
          });
          document.dispatchEvent(hcPriceUpdate);
        }
      }

      if (hcType === 'summary') {
        document.querySelectorAll('.hc-type-section').forEach(el => el.classList.remove('hc-hidden'));
      } else {
        document.querySelectorAll('.hc-type-section').forEach(el => el.classList.remove('hc-hidden'));
      }
    }
  }

  const $popupItems = $('.hc-popup-items');
  const $header = $('.shopify-section-group-header-group');
  const $backTrigger = $('.hc-back-trigger');
  const $announcement = $('.announcement');

  if ($popupItems.scrollTop() >= 200) {
    $header.addClass('hc-not-fixed');
    $backTrigger.addClass('hc-not-fixed');
    $announcement.addClass('hc-not-fixed');
  } else {
    $header.removeClass('hc-not-fixed');
    $backTrigger.removeClass('hc-not-fixed');
    $announcement.removeClass('hc-not-fixed');
  }
}, true);

document.addEventListener("hcMainUpdate", e => {
  
  var hcVariants = $(".hc-main-slider-default").attr('data-variants');
  if(hcVariants != '1'){
    if($('.hc-main-slider-default').length){
      $(hcMainSlidesDef).each(function () {
        if($(this).hasClass('hc-'+hcValue)){          
          hcMainDefault.appendSlide(this);
        } else {
          jQuery(this).remove();
        }
      });
    
      hcMainDefault.update();
      hcMainDefault.slideTo(0, false);
    }
  }
});